module.exports = __webpack_public_path__ + "media/images/logo-compleet-wit3-213666ec4d73845375b58304e468357a.svg";